/**
 * Utility for storing user preferences for DateTimeCell display mode
 */

const STORAGE_KEY = 'datetime-cell-view-preference';

export type DateTimeViewMode = 'relative' | 'absolute';

export interface DateTimePreference {
  viewMode: DateTimeViewMode;
  savedAt: string;
}

/**
 * Save user preference for DateTimeCell view mode
 */
export const saveDateTimePreference = (viewMode: DateTimeViewMode): void => {
  try {
    const preference: DateTimePreference = {
      viewMode,
      savedAt: new Date().toISOString(),
    };

    localStorage.setItem(STORAGE_KEY, JSON.stringify(preference));
  } catch (error) {
    console.error('Failed to save DateTimeCell preference:', error);
  }
};

/**
 * Load user preference for DateTimeCell view mode
 * Returns 'relative' as default if no preference is saved
 */
export const loadDateTimePreference = (): DateTimeViewMode => {
  try {
    const preference = localStorage.getItem(STORAGE_KEY);

    if (preference) {
      const parsed: DateTimePreference = JSON.parse(preference);
      return parsed.viewMode;
    }

    return 'relative'; // Default to relative time
  } catch (error) {
    console.error('Failed to load DateTimeCell preference:', error);
    return 'relative'; // Default to relative time on error
  }
};

/**
 * Clear saved preference
 */
export const clearDateTimePreference = (): void => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.error('Failed to clear DateTimeCell preference:', error);
  }
};

